<template>
  <div class="min-h-screen h-full">
    <div class="container mx-auto py-16 px-6">
      <h1 class="py-8 font-extrabold text-4xl">{{ title }}</h1>
      <div class="container mx-auto section-question">
        <v-runtime-template :template="`<div>${body}</div>`"></v-runtime-template>
      </div>
    </div>
  </div>
</template>
<script>
import VRuntimeTemplate from "v-runtime-template";
import { mapActions, mapState } from "vuex";
import Tooltip from "@/components/Tooltip";
export default {
  name: "Conduct",
  layout: "default",
  metaInfo: {
    titleTemplate: "%s | Conduct"
  },
  components: {
    Tooltip,
    VRuntimeTemplate
  },
  props: {
    title: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    }
  }
  // computed: {
  //   parseBody() {
  //     return `<div>${this.page.body[this.locale]}</div>`;
  //   }
  // },
};
</script>
<style lang="scss">
$blue-color: #0669f9;
$grey-color: #1b1b1b;
.section-question {
  h3 {
    color: $blue-color;
    font-weight: bold;
  }
  p {
    color: $grey-color;
    font-size: 1em;
    font-weight: 500;
    padding-top: 10px;
  }
  b {
    color: #000;
  }
  a {
    color: #0669f9;
    font-weight: bold;
  }
  .cite {
    color: #0669f9;
    font-weight: bold;
  }
}
.section-question > div {
  text-align: justify;
}
</style>
